import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { SurveyDialogProps, TMSEDefaultValues } from 'routes/Main/Survey/type';
import MuiDialog from 'components/MuiDialog';
import { findKeyValueToStr } from 'utils/convert';
import { createMSE } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import Extroversion from './Extroversion';
import Language from './Language';
import MoodAffect from './MoodAffect';
import Orientation from './Orientation';
import Accident from './Accident';
import Recognition from './Recognition';
import Memory from './Memory';
import Disease from './Disease';
import Attention from './Attention';
import Judgement from './Judgement';

const MSE = (props: SurveyDialogProps<TMSEDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch, control } =
    useForm({
      defaultValues,
    });

  const onSubmit = (data: TMSEDefaultValues) => {
    const {
      extroversion,
      language,
      mood_affect,
      orientation,
      accident,
      recognition,
      memory,
      attention,
      judgement,
      disease,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      mse_survey: {
        patient_id: patientInfo.patient_id,

        extroversion: findKeyValueToStr(extroversion),
        language: findKeyValueToStr(language),
        mood_affect: findKeyValueToStr(mood_affect),
        orientation: findKeyValueToStr(orientation),
        accident: findKeyValueToStr(accident),
        recognition: findKeyValueToStr(recognition),
        memory: findKeyValueToStr(memory),
        attention: findKeyValueToStr(attention),
        judgement: findKeyValueToStr(judgement),
        disease: findKeyValueToStr(disease),
      },
    };

    createMSE(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    control,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={2}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          정신상태검사 (Mental Status Examination: MSE)
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <Extroversion {...formProps} />
        <Language {...formProps} />
        <MoodAffect {...formProps} />
        <Orientation {...formProps} gender={patientInfo.gender} />
        <Accident {...formProps} />
        <Recognition {...formProps} />
        <Memory {...formProps} />
        <Attention {...formProps} />
        <Judgement {...formProps} />
        <Disease {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default MSE;
